var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{attrs:{"disabled":_vm.disabled,"aria-label":_vm.$t(_vm.text)},on:{"click":function($event){return _vm.click($event)}}},[_c('sword-icon',{attrs:{"name":"back-arrow"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }